<template>
  <v-row no-gutters align="center" :class="rowClasses.join()">
    <v-col :cols="titleCols" :class="titleClasses.join()">
      <v-row align="center" no-gutters>
        <v-col cols="auto" class="text-left" v-if="checkboxValue">
          <v-checkbox
            hide-details
            class="py-0 my-0 black-label"
            color="primary"
            :value="checkboxValue"
            v-model="computedCheckboxesValues"
          ></v-checkbox>
        </v-col>
        <v-col cols="auto" class="text-left summary-text"> {{ summaryText }}: </v-col>
      </v-row>
    </v-col>
    <v-col :cols="valueCols" :class="valueClasses.join()">
      <v-tooltip bottom color="font" :disabled="!chipTooltip">
        <template #activator="{ on }">
          <v-chip
            label
            :color="color"
            :text-color="isColorLight ? 'black' : 'white'"
            class="px-2 summary-chip-text x-small"
            style="height: 24px"
            v-on="on"
          >
            <slot :name="name">
              {{ value }}
            </slot>
          </v-chip>
        </template>
        {{ chipTooltip }}
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SidebarSummaryRow',
  props: {
    name: {
      type: String,
    },
    translationPath: {
      type: String,
    },
    color: {
      type: String,
      default: 'red',
    },
    straightText: {
      type: String,
    },
    value: {
      default: '',
    },
    checkboxValue: {
      default: '',
    },
    checkboxesValues: {
      type: Array,
      default: () => {
        return [];
      },
    },
    chipTooltip: {
      type: String,
    },
    titleCols: {
      type: [Number, String],
      default: 8,
    },
    valueCols: {
      type: [Number, String],
      default: 'auto',
    },
    titleClasses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    valueClasses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    rowClasses: {
      type: Array,
      default: () => {
        return ['py-2'];
      },
    },
  },
  computed: {
    computedCheckboxesValues: {
      get() {
        return this.checkboxesValues;
      },
      set(nV) {
        this.$emit('updateCheckboxesValues', nV);
      },
    },
    isColorLight() {
      return this.$_isHexColorLight(this.color);
    },
    summaryText() {
      return this.straightText ? this.straightText : this.translationPath ? this.$i18n.t(this.translationPath) : '';
    },
  },
};
</script>
<style lang="scss" scoped>
.summary-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #202124;
}
.summary-chip-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
</style>
